<template>
  <div>
    <template v-if="!hasChild(item)">
      <el-menu-item
        :class="{ 'submenu-title-noDropdown': !isNest }"
        :index="item.id"
        @click="handlePosition(item.id)"
      >
        <svg-icon :icon-name="item.categoryIcon" />
        <template #title
          ><span class="menu-title">{{ item.categoryName }}</span></template
        >
      </el-menu-item>
    </template>

    <el-sub-menu v-else ref="subMenu" popper-append-to-body :index="item.id">
      <template #title>
        <svg-icon :icon-name="item.categoryIcon" />
        <span class="menu-title">{{ item.categoryName }}</span>
      </template>

      <sidebar-item
        v-for="child in item.children"
        :key="child.id"
        :is-nest="true"
        :item="child"
        class="nest-menu"
      />
    </el-sub-menu>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { openSite } from '@/utils/geshanzsq'

defineProps({
  // route object
  item: {
    type: Object,
    required: true
  }
})

const router = useRouter()

/**
 * 是否有子分类
 */
function hasChild(category) {
  if (
    category.children === null ||
    category.children === undefined ||
    category.children.length === 0
  ) {
    return false
  }
  return true
}

/**
 * 瞄点定位
 */
function handlePosition(id) {
  try {
    if (!id) {
      return
    }
    openSite('/cate/get/' + id)
  } catch (e) {
    console.error(e)
    router.push('/')
  }
}
</script>
